import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import blogData from '../data/blogData';
import SocialLinks from './SocialLinks';
import SEO from './SEO';

const BlogPost = () => {
    const { id } = useParams();
    const blog = blogData.find(b => b.id === parseInt(id));

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    if (!blog) {
        return (
            <div className="section container" style={{ textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <h2>Article Not Found</h2>
                <Link to="/blogs" className="button button-primary">Back to Blogs</Link>
            </div>
        );
    }

    return (
        <article className="blog-post-page">
            <SEO 
                title={blog.title} 
                description={blog.summary} 
                canonical={`/blogs/${blog.id}`}
                articleData={{
                    title: blog.title,
                    image: blog.previewImage,
                    date: blog.date,
                    summary: blog.summary
                }}
            />
            <div className="blog-hero" style={{ backgroundImage: `url(${blog.previewImage})` }}>
                <div className="blog-hero-overlay">
                    <div className="container">
                        <Link to="/blogs" className="back-link">&larr; Back to Blogs</Link>
                        <h1 className="blog-title">{blog.title}</h1>
                        <div className="blog-meta">
                            <span>{blog.date}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="blog-content-wrapper">
                    <div className="blog-content" dangerouslySetInnerHTML={{ __html: blog.content }}></div>
                </div>

                <div className="blog-footer">
                    <div className="blog-share-section">
                        <h3>Share this article</h3>
                        <SocialLinks style={{ justifyContent: 'center' }} showLabel={false} />
                    </div>

                    <div className="blog-cta">
                        <h2>Start Your Gut Health Journey Today</h2>
                        <p>Get personalized insights and track your progress with the Nouria app.</p>
                        <a href="https://play.google.com/store/apps/details?id=com.masalachailabs.nouria" target="_blank" rel="noopener noreferrer" className="play-store-badge-link">
                            <img src="/google-play-badge-en.webp" alt="Get it on Google Play" className="play-store-badge-img" style={{ height: '60px' }} />
                        </a>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default BlogPost;
